module.exports = __webpack_public_path__ + "img/forbidden.c7e706bd.svg";